import { render, staticRenderFns } from "./xunjia.vue?vue&type=template&id=1a93fffa"
import script from "./xunjia.vue?vue&type=script&lang=js"
export * from "./xunjia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports